import { Region } from "../interfaces/types";

export const regiones: Region[] = [
  {
    id: 1,
    nombre: 'Arica y Parinacota',
    comunas: [
      { id: 1, nombre: 'Arica' },
      { id: 2, nombre: 'Camarones' },
      { id: 4, nombre: 'General Lagos' },
      { id: 3, nombre: 'Putre' }
    ]
  },
  {
    id: 2,
    nombre: 'Tarapacá',
    comunas: [
      { id: 6, nombre: 'Alto Hospicio' },
      { id: 9, nombre: 'Camiña' },
      { id: 10, nombre: 'Colchane' },
      { id: 11, nombre: 'Huara' },
      { id: 5, nombre: 'Iquique' },
      { id: 7, nombre: 'Pica' },
      { id: 8, nombre: 'Pozo Almonte' }
    ]
  },
  {
    id: 3,
    nombre: 'Antofagasta',
    comunas: [
      { id: 12, nombre: 'Antofagasta' },
      { id: 16, nombre: 'Calama' },
      { id: 20, nombre: 'María Elena' },
      { id: 13, nombre: 'Mejillones' },
      { id: 17, nombre: 'Ollagüe' },
      { id: 18, nombre: 'San Pedro de Atacama' },
      { id: 14, nombre: 'Sierra Gorda' },
      { id: 15, nombre: 'Taltal' },
      { id: 19, nombre: 'Tocopilla' }
    ]
  },
  {
    id: 4,
    nombre: 'Atacama',
    comunas: [
      { id: 27, nombre: 'Alto del Carmen' },
      { id: 22, nombre: 'Caldera' },
      { id: 24, nombre: 'Chañaral' },
      { id: 21, nombre: 'Copiapó' },
      { id: 25, nombre: 'Diego de Almagro' },
      { id: 28, nombre: 'Freirina' },
      { id: 29, nombre: 'Huasco' },
      { id: 23, nombre: 'Tierra Amarilla' },
      { id: 26, nombre: 'Vallenar' }
    ]
  },
  {
    id: 5,
    nombre: 'Coquimbo',
    comunas: [
      { id: 32, nombre: 'Andacollo' },
      { id: 37, nombre: 'Canela' },
      { id: 41, nombre: 'Combarbalá' },
      { id: 31, nombre: 'Coquimbo' },
      { id: 36, nombre: 'Illapel' },
      { id: 33, nombre: 'La Higuera' },
      { id: 30, nombre: 'La Serena' },
      { id: 38, nombre: 'Los Vilos' },
      { id: 42, nombre: 'Monte Patria' },
      { id: 40, nombre: 'Ovalle' },
      { id: 34, nombre: 'Paiguano' },
      { id: 43, nombre: 'Punitaqui' },
      { id: 44, nombre: 'Río Hurtado' },
      { id: 39, nombre: 'Salamanca' },
      { id: 35, nombre: 'Vicuña' }
    ]
  },
  {
    id: 6,
    nombre: 'Valparaíso',
    comunas: [
      { id: 58, nombre: 'Algarrobo' },
      { id: 64, nombre: 'Cabildo' },
      { id: 61, nombre: 'Calle Larga' },
      { id: 57, nombre: 'Cartagena' },
      { id: 52, nombre: 'Casablanca' },
      { id: 49, nombre: 'Concón' },
      { id: 54, nombre: 'El Quisco' },
      { id: 55, nombre: 'El Tabo' },
      { id: 70, nombre: 'Hijuelas' },
      { id: 75, nombre: 'Isla de Pascua' },
      { id: 76, nombre: 'Juan Fernández' },
      { id: 69, nombre: 'La Calera' },
      { id: 71, nombre: 'La Cruz' },
      { id: 63, nombre: 'La Ligua' },
      { id: 73, nombre: 'Limache' },
      { id: 59, nombre: 'Los Andes' },
      { id: 72, nombre: 'Nogales' },
      { id: 74, nombre: 'Olmué' },
      { id: 67, nombre: 'Papudo' },
      { id: 65, nombre: 'Petorca' },
      { id: 50, nombre: 'Puchuncaví' },
      { id: 68, nombre: 'Quillota' },
      { id: 47, nombre: 'Quilpué' },
      { id: 51, nombre: 'Quintero' },
      { id: 62, nombre: 'Rinconada' },
      { id: 53, nombre: 'San Antonio' },
      { id: 60, nombre: 'San Esteban' },
      { id: 56, nombre: 'Santo Domingo' },
      { id: 45, nombre: 'Valparaíso' },
      { id: 48, nombre: 'Villa Alemana' },
      { id: 46, nombre: 'Viña del Mar' },
      { id: 66, nombre: 'Zapallar' }
    ]
  },
  {
    id: 7,
    nombre: 'Metropolitana de Santiago',
    comunas: [
      { id: 120, nombre: 'Alhué' },
      { id: 116, nombre: 'Buin' },
      { id: 117, nombre: 'Calera de Tango' },
      { id: 86, nombre: 'Cerro Navia' },
      { id: 91, nombre: 'Cerrillos' },
      { id: 89, nombre: 'Colina' },
      { id: 92, nombre: 'Conchalí' },
      { id: 121, nombre: 'Curacaví' },
      { id: 93, nombre: 'El Bosque' },
      { id: 125, nombre: 'El Monte' },
      { id: 94, nombre: 'Estación Central' },
      { id: 95, nombre: 'Huechuraba' },
      { id: 96, nombre: 'Independencia' },
      { id: 126, nombre: 'Isla de Maipo' },
      { id: 97, nombre: 'La Cisterna' },
      { id: 82, nombre: 'La Florida' },
      { id: 98, nombre: 'La Granja' },
      { id: 99, nombre: 'La Pintana' },
      { id: 100, nombre: 'La Reina' },
      { id: 88, nombre: 'Lampa' },
      { id: 80, nombre: 'Las Condes' },
      { id: 101, nombre: 'Lo Barnechea' },
      { id: 102, nombre: 'Lo Espejo' },
      { id: 103, nombre: 'Lo Prado' },
      { id: 104, nombre: 'Macul' },
      { id: 79, nombre: 'Maipú' },
      { id: 122, nombre: 'María Pinto' },
      { id: 119, nombre: 'Melipilla' },
      { id: 105, nombre: 'Ñuñoa' },
      { id: 127, nombre: 'Padre Hurtado' },
      { id: 118, nombre: 'Paine' },
      { id: 106, nombre: 'Pedro Aguirre Cerda' },
      { id: 128, nombre: 'Peñaflor' },
      { id: 107, nombre: 'Peñalolén' },
      { id: 114, nombre: 'Pirque' },
      { id: 108, nombre: 'Providencia' },
      { id: 84, nombre: 'Pudahuel' },
      { id: 78, nombre: 'Puente Alto' },
      { id: 87, nombre: 'Quilicura' },
      { id: 109, nombre: 'Quinta Normal' },
      { id: 110, nombre: 'Recoleta' },
      { id: 85, nombre: 'Renca' },
      { id: 83, nombre: 'San Bernardo' },
      { id: 111, nombre: 'San Joaquín' },
      { id: 115, nombre: 'San José de Maipo' },
      { id: 112, nombre: 'San Miguel' },
      { id: 123, nombre: 'San Pedro' },
      { id: 113, nombre: 'San Ramón' },
      { id: 77, nombre: 'Santiago' },
      { id: 124, nombre: 'Talagante' },
      { id: 90, nombre: 'Tiltil' },
      { id: 81, nombre: 'Vitacura' }
    ]
  },
  {
    id: 8,
    nombre: 'O’Higgins',
    comunas: [
      { id: 138, nombre: 'Chimbarongo' },
      { id: 131, nombre: 'Codegua' },
      { id: 147, nombre: 'Coinco' },
      { id: 146, nombre: 'Coltauco' },
      { id: 145, nombre: 'Doñihue' },
      { id: 132, nombre: 'Graneros' },
      { id: 158, nombre: 'La Estrella' },
      { id: 137, nombre: 'Las Cabras' },
      { id: 157, nombre: 'Litueche' },
      { id: 160, nombre: 'Lolol' },
      { id: 130, nombre: 'Machalí' },
      { id: 150, nombre: 'Malloa' },
      { id: 155, nombre: 'Marchigüe' },
      { id: 144, nombre: 'Mostazal' },
      { id: 142, nombre: 'Nancagua' },
      { id: 156, nombre: 'Navidad' },
      { id: 148, nombre: 'Olivar' },
      { id: 139, nombre: 'Palmilla' },
      { id: 136, nombre: 'Pangallí' },
      { id: 159, nombre: 'Paredones' },
      { id: 140, nombre: 'Peralillo' },
      { id: 152, nombre: 'Peumo' },
      { id: 135, nombre: 'Pichidegua' },
      { id: 154, nombre: 'Pichilemu' },
      { id: 141, nombre: 'Placilla' },
      { id: 151, nombre: 'Quinta de Tilcoco' },
      { id: 129, nombre: 'Rancagua' },
      { id: 133, nombre: 'Rengo' },
      { id: 149, nombre: 'Requínoa' },
      { id: 153, nombre: 'San Fernando' },
      { id: 134, nombre: 'San Vicente' },
      { id: 143, nombre: 'Santa Cruz' }
    ]
  },
  {
    id: 9,
    nombre: 'Maule',
    comunas: [
      { id: 162, nombre: 'Cauquenes' },
      { id: 180, nombre: 'Chanco' },
      { id: 163, nombre: 'Colbún' },
      { id: 176, nombre: 'Constitución' },
      { id: 181, nombre: 'Curicó' },
      { id: 175, nombre: 'Curepto' },
      { id: 177, nombre: 'Empedrado' },
      { id: 186, nombre: 'Hualañé' },
      { id: 187, nombre: 'Licantén' },
      { id: 164, nombre: 'Linares' },
      { id: 165, nombre: 'Longaví' },
      { id: 166, nombre: 'Maule' },
      { id: 184, nombre: 'Molina' },
      { id: 178, nombre: 'Parral' },
      { id: 172, nombre: 'Pelarco' },
      { id: 179, nombre: 'Pelluhue' },
      { id: 189, nombre: 'Rauco' },
      { id: 167, nombre: 'Retiro' },
      { id: 173, nombre: 'Río Claro' },
      { id: 183, nombre: 'Romeral' },
      { id: 185, nombre: 'Sagrada Familia' },
      { id: 171, nombre: 'San Clemente' },
      { id: 168, nombre: 'San Javier' },
      { id: 174, nombre: 'San Rafael' },
      { id: 161, nombre: 'Talca' },
      { id: 182, nombre: 'Teno' },
      { id: 188, nombre: 'Vichuquén' },
      { id: 169, nombre: 'Villa Alegre' },
      { id: 170, nombre: 'Yerbas Buenas' }
    ]
  },
  {
    id: 10,
    nombre: 'Ñuble',
    comunas: [
      { id: 196, nombre: 'Bulnes' },
      { id: 190, nombre: 'Chillán' },
      { id: 191, nombre: 'Chillán Viejo' },
      { id: 204, nombre: 'Cobquecura' },
      { id: 210, nombre: 'Coelemu' },
      { id: 201, nombre: 'Coihueco' },
      { id: 192, nombre: 'El Carmen' },
      { id: 205, nombre: 'Ninhue' },
      { id: 200, nombre: 'Ñiquén' },
      { id: 193, nombre: 'Pemuco' },
      { id: 202, nombre: 'Pinto' },
      { id: 206, nombre: 'Portezuelo' },
      { id: 203, nombre: 'Quirihue' },
      { id: 197, nombre: 'Quillón' },
      { id: 207, nombre: 'Ránquil' },
      { id: 198, nombre: 'San Carlos' },
      { id: 209, nombre: 'San Fabián' },
      { id: 194, nombre: 'San Ignacio' },
      { id: 199, nombre: 'San Nicolás' },
      { id: 208, nombre: 'Treguaco' },
      { id: 195, nombre: 'Yungay' }
    ]
  },
  {
    id: 11,
    nombre: 'Biobío',
    comunas: [
      { id: 242, nombre: 'Alto Biobío' },
      { id: 230, nombre: 'Antuco' },
      { id: 222, nombre: 'Arauco' },
      { id: 231, nombre: 'Cabrero' },
      { id: 220, nombre: 'Cañete' },
      { id: 224, nombre: 'Chiguayante' },
      { id: 211, nombre: 'Concepción' },
      { id: 217, nombre: 'Coronel' },
      { id: 223, nombre: 'Curanilahue' },
      { id: 218, nombre: 'Florida' },
      { id: 225, nombre: 'Hualqui' },
      { id: 214, nombre: 'Hualpén' },
      { id: 232, nombre: 'Laja' },
      { id: 221, nombre: 'Lebu' },
      { id: 228, nombre: 'Los Álamos' },
      { id: 229, nombre: 'Los Ángeles' },
      { id: 216, nombre: 'Lota' },
      { id: 233, nombre: 'Mulchén' },
      { id: 234, nombre: 'Nacimiento' },
      { id: 235, nombre: 'Negrete' },
      { id: 215, nombre: 'Penco' },
      { id: 236, nombre: 'Quilaco' },
      { id: 237, nombre: 'Quilleco' },
      { id: 213, nombre: 'San Pedro de la Paz' },
      { id: 238, nombre: 'San Rosendo' },
      { id: 239, nombre: 'Santa Bárbara' },
      { id: 226, nombre: 'Santa Juana' },
      { id: 212, nombre: 'Talcahuano' },
      { id: 219, nombre: 'Tirúa' },
      { id: 227, nombre: 'Tomé' },
      { id: 240, nombre: 'Tucapel' },
      { id: 241, nombre: 'Yumbel' }
    ]
  },
  {
    id: 12,
    nombre: 'La Araucanía',
    comunas: [
      { id: 264, nombre: 'Angol' },
      { id: 263, nombre: 'Cholchol' },
      { id: 265, nombre: 'Collipulli' },
      { id: 253, nombre: 'Cunco' },
      { id: 266, nombre: 'Curacautín' },
      { id: 254, nombre: 'Curarrehue' },
      { id: 267, nombre: 'Ercilla' },
      { id: 247, nombre: 'Freire' },
      { id: 255, nombre: 'Galvarino' },
      { id: 248, nombre: 'Gorbea' },
      { id: 249, nombre: 'Lautaro' },
      { id: 256, nombre: 'Loncoche' },
      { id: 268, nombre: 'Lonquimay' },
      { id: 269, nombre: 'Los Sauces' },
      { id: 270, nombre: 'Lumaco' },
      { id: 250, nombre: 'Melipeuco' },
      { id: 251, nombre: 'Nueva Imperial' },
      { id: 244, nombre: 'Padre Las Casas' },
      { id: 257, nombre: 'Perquenco' },
      { id: 258, nombre: 'Pitrufquén' },
      { id: 246, nombre: 'Pucón' },
      { id: 271, nombre: 'Purén' },
      { id: 272, nombre: 'Renaico' },
      { id: 259, nombre: 'Saavedra' },
      { id: 243, nombre: 'Temuco' },
      { id: 252, nombre: 'Temuco' },
      { id: 260, nombre: 'Teodoro Schmidt' },
      { id: 261, nombre: 'Toltén' },
      { id: 273, nombre: 'Traiguén' },
      { id: 274, nombre: 'Victoria' },
      { id: 262, nombre: 'Vilcún' },
      { id: 245, nombre: 'Villarrica' }
    ]
  },
  {
    id: 13,
    nombre: 'Los Ríos',
    comunas: [
      { id: 281, nombre: 'Corral' },
      { id: 279, nombre: 'Futrono' },
      { id: 278, nombre: 'Lago Ranco' },
      { id: 282, nombre: 'Lanco' },
      { id: 276, nombre: 'La Unión' },
      { id: 280, nombre: 'Los Lagos' },
      { id: 283, nombre: 'Máfil' },
      { id: 284, nombre: 'Mariquina' },
      { id: 285, nombre: 'Paillaco' },
      { id: 286, nombre: 'Panguipulli' },
      { id: 277, nombre: 'Río Bueno' },
      { id: 275, nombre: 'Valdivia' }
    ]
  },
  {
    id: 14,
    nombre: 'Los Lagos',
    comunas: [
      { id: 291, nombre: 'Ancud' },
      { id: 293, nombre: 'Calbuco' },
      { id: 290, nombre: 'Castro' },
      { id: 313, nombre: 'Chaitén' },
      { id: 299, nombre: 'Chonchi' },
      { id: 294, nombre: 'Cochamó' },
      { id: 300, nombre: 'Curaco de Vélez' },
      { id: 301, nombre: 'Dalcahue' },
      { id: 295, nombre: 'Fresia' },
      { id: 289, nombre: 'Frutillar' },
      { id: 314, nombre: 'Futaleufú' },
      { id: 315, nombre: 'Hualaihué' },
      { id: 297, nombre: 'Llanquihue' },
      { id: 296, nombre: 'Los Muermos' },
      { id: 298, nombre: 'Maullín' },
      { id: 306, nombre: 'Osorno' },
      { id: 316, nombre: 'Palena' },
      { id: 287, nombre: 'Puerto Montt' },
      { id: 307, nombre: 'Puerto Octay' },
      { id: 288, nombre: 'Puerto Varas' },
      { id: 302, nombre: 'Puqueldón' },
      { id: 308, nombre: 'Purranque' },
      { id: 309, nombre: 'Puyehue' },
      { id: 303, nombre: 'Queilén' },
      { id: 292, nombre: 'Quellón' },
      { id: 304, nombre: 'Quemchi' },
      { id: 305, nombre: 'Quinchao' },
      { id: 310, nombre: 'Río Negro' },
      { id: 311, nombre: 'San Juan de la Costa' },
      { id: 312, nombre: 'San Pablo' }
    ]
  },
  {
    id: 15,
    nombre: 'Aysén del General Carlos Ibáñez del Campo',
    comunas: [
      { id: 318, nombre: 'Aysén' },
      { id: 319, nombre: 'Chile Chico' },
      { id: 320, nombre: 'Cisnes' },
      { id: 323, nombre: 'Cochrane' },
      { id: 317, nombre: 'Coyhaique' },
      { id: 321, nombre: 'Guaitecas' },
      { id: 322, nombre: 'Lago Verde' },
      { id: 324, nombre: 'O’Higgins' },
      { id: 326, nombre: 'Río Ibáñez' },
      { id: 325, nombre: 'Tortel' }
    ]
  },
  {
    id: 16,
    nombre: 'Magallanes y de la Antártica Chilena',
    comunas: [
      { id: 331, nombre: 'Antártica' },
      { id: 335, nombre: 'Cabo de Hornos' },
      { id: 329, nombre: 'Cerro Castillo' },
      { id: 332, nombre: 'Laguna Blanca' },
      { id: 336, nombre: 'Porvenir' },
      { id: 337, nombre: 'Primavera' },
      { id: 328, nombre: 'Puerto Natales' },
      { id: 327, nombre: 'Punta Arenas' },
      { id: 333, nombre: 'Río Verde' },
      { id: 334, nombre: 'San Gregorio' },
      { id: 330, nombre: 'Timaukel' },
      { id: 338, nombre: 'Torres del Paine' }
    ]
  }
];
